import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
} from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { useQuickMessageService } from '../../hooks/useQuickMessageService';
import { ModalOptions } from './types';

export function ModalRemoveQuickMessage(props: Readonly<ModalOptions>) {
  // Traduções
  const deleteQuickMessageTitle = useGlotaT('spa.messageBuilder.quickMessagesDetails.deleteTitle');
  const deleteQuickMessageConfirm = useGlotaT('spa.messageBuilder.quickMessagesDetails.deleteConfirm');
  const deleteText = useGlotaT('spa.common.delete');
  const removingText = useGlotaT('spa.messageBuilder.quickMessagesDetails.removing');
  const successRemovedText = useGlotaT('spa.messageBuilder.quickMessagesDetails.successRemoved');
  const isLoading = useSelector(
    (state: any) => state?.chat?.quickMessages?.loadingDelete
  ) as boolean | undefined;

  const successRemove = useSelector(
    (state: any) => state?.chat?.quickMessages?.removeSuccess
  ) as boolean | undefined;

  const { remove } = useQuickMessageService();

  const handleCloseModal = useCallback(() => {
    props.handleClose();
  }, []);

  const handleRemove = useCallback(() => {
    if (props.message) remove(props.message);
  }, [props.message]);

  useEffect(() => {
    if (successRemove) {
      toast.success(successRemovedText);
      handleCloseModal();
    }
  }, [successRemove, successRemovedText]);

  return (
    <Modal isOpen={props.isOpen} toggle={handleCloseModal}>
      <ModalHeader toggle={handleCloseModal}>
        {deleteQuickMessageTitle}
      </ModalHeader>
      <ModalBody>
        <div>
          <p>{deleteQuickMessageConfirm}</p>
          <Row>
            <Col>
              <FormGroup style={{ textAlign: 'center' }}>
                <Button onClick={handleRemove} color="danger">
                  {!isLoading ? deleteText : removingText}
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
}
